interface UserIconProps {
  className?: string;
}

const UserIcon: React.FC<UserIconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        width="20"
        height="18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 16.635a16.693 16.693 0 0 1 18-.002" stroke="#172A4F" strokeWidth="2" />
        <rect x="6" y="1" width="8" height="8" rx="4" stroke="#172A4F" strokeWidth="2" />
      </svg>
    </>
  );
};

export default UserIcon;
